import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { USER_READ_CURRENT } from "../../queries";
import { personExample } from "./dossier-read";
export const userExample = {
  id: 5001,
  alias: 'isyc',
  locked: false,
  username: 'isyc',
  email: 'isyc@isyc.com',
  phoneNumber: '',
  phonePrefix: '',
  businessUnits: [{
    id: 5100,
    name: 'General',
    code: 'SHARE'
  }],
  businessUnit: {
    id: 5100,
    name: 'General',
    code: 'SHARE'
  },
  language: 'es',
  person: personExample,
  userPicture: '',
  roles: [{
    id: 0,
    name: ''
  }]
};
export default [{
  request: {
    query: USER_READ_CURRENT
  },
  result: {
    data: {
      user_read_current: _objectSpread(_objectSpread({}, userExample), {}, {
        __typename: 'UserDto'
      })
    }
  }
}];